import React from "react";
import { Link } from "react-router-dom";

import spotify from "../assets/logo/spotify.png";
import deezer from "../assets/logo/deezer-logo-coeur.png";
import apple from "../assets/logo/apple.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-info">
        <div className="footer-info-liens">
          <Link to="/faq">F.A.Q</Link>
          <Link to="/contact">Me contacter</Link>
          <Link to="/remerciements">Remerciements</Link>
        </div>

        <div className="footer-music">
          <a
            href="http://itunes.apple.com/album/id1744168659?ls=1&app=itunes"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={apple} alt="Apple Music" className="footer-icon" />
          </a>

          <a
            href="https://open.spotify.com/intl-fr/album/0pQ2xFwiX6DIn1ZHHMprO9"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={spotify} alt="Spotify" className="footer-icon" />
          </a>

          <a
            href="https://www.deezer.com/fr/album/258947952"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={deezer} alt="Deezer" className="footer-icon" />
          </a>
        </div>
      </div>

      <div className="footer-dev">
        Copyright © 2023 – Designed & Developed by&nbsp;
        <a
          href="https://www.maissadev.com"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-wrap"
        >
          Maissa Dev
        </a>
      </div>
    </footer>
  );
};
